<h2 mat-dialog-title>Exportar Dados</h2>

<div mat-dialog-content>
  <div class="exportacao-dialog__secao">
    <p class="exportacao-dialog__label">O que deseja exportar?</p>
    <mat-radio-group [(ngModel)]="tipoExportacao" class="exportacao-dialog__opcoes">
      <mat-radio-button value="todos" class="exportacao-dialog__opcao">
        Todos os registros filtrados
        <span class="exportacao-dialog__quantidade">({{ data.totalRegistros }} registros)</span>
      </mat-radio-button>
      <mat-radio-button value="pagina" class="exportacao-dialog__opcao">
        Apenas a página atual
        <span class="exportacao-dialog__quantidade">({{ data.totalPagina }} registros)</span>
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="exportacao-dialog__secao">
    <p class="exportacao-dialog__label">Formato do arquivo:</p>
    <mat-radio-group [(ngModel)]="formatoExportacao" class="exportacao-dialog__opcoes exportacao-dialog__opcoes--horizontal">
      <mat-radio-button value="xlsx" class="exportacao-dialog__opcao">
        Excel (.xlsx)
      </mat-radio-button>
      <mat-radio-button value="csv" class="exportacao-dialog__opcao">
        CSV (.csv)
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancelar()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="onConfirmar()">
    <mat-icon>download</mat-icon>
    Exportar
  </button>
</div>
